import {initSectionsWithIntersection} from '@scripts/helpers/block.js';

const initializeBlock = async (section) => {
  const {gsap} = await import('gsap');
  const {MotionPathPlugin} = await import('gsap/MotionPathPlugin');

  gsap.registerPlugin(MotionPathPlugin);

  const svg = section.querySelector('.b-group-hero__anim-circles');
  if (!svg) return;

  const circles = svg?.querySelectorAll('path');
  const photos = section.querySelectorAll('.b-group-hero__anim-photo');
  const logotypes = section.querySelectorAll('.b-group-hero__anim-logo');
  const circleAnim = (photo, circle, start) => {
    let tween;

    const fallbacks = [];

    // eslint-disable-next-line no-unused-vars
    const updateAnimation = () => {
      let progress = tween ? tween.totalProgress() : 0;
      tween && tween.revert();
      tween = gsap.to(photo, {
        duration: 60,
        repeat: -1,
        ease: 'linear',
        motionPath: {
          path: circle,
          align: circle,
          alignOrigin: [0.5, 0.5],
          start: start,
          end: start + 1,
        },
      });
      tween.totalProgress(progress);
    };
    fallbacks.push(updateAnimation);

    const resizeObserver = new ResizeObserver(() => {
      fallbacks.forEach((fallback) => fallback());
    });

    resizeObserver.observe(svg);
  };

  if (photos[0]) {
    circleAnim(photos[0], circles[0], 0.3);
  }

  if (photos[1]) {
    circleAnim(photos[1], circles[1], 0.55);
  }

  if (photos[2]) {
    circleAnim(photos[2], circles[0], 0.9);
  }

  if (photos[3]) {
    circleAnim(photos[3], circles[1], 0.35);
  }

  if (photos[4]) {
    circleAnim(photos[4], circles[1], 0.9);
  }

  if (logotypes[0]) {
    circleAnim(logotypes[0], circles[1], 0.75);
  }

  if (logotypes[1]) {
    circleAnim(logotypes[1], circles[0], 0.6);
  }

  if (logotypes[2]) {
    circleAnim(logotypes[2], circles[1], 0);
  }
};

initSectionsWithIntersection(async () => {
  return Array.from(document.getElementsByClassName('b-group-hero'));
}, initializeBlock);

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
